import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '@iw/environment';

import { WithdrawalApi } from './withdrawal-api.interface';
import {
  EstimateFeeReq,
  EstimateFeeRes,
  WithdrawalReq,
  WithdrawalRes,
} from '../entities';

@Injectable()
export class WithdrawalApiService implements WithdrawalApi {
  readonly #http = inject(HttpClient);
  readonly #apiHost = environment.apiHost;

  withdrawal(body: WithdrawalReq): Observable<WithdrawalRes> {
    return this.#http.post<WithdrawalRes>(
      `${this.#apiHost}operations/withdrawals/`,
      body,
    );
  }

  estimateFee(body: EstimateFeeReq): Observable<EstimateFeeRes> {
    return this.#http.post<EstimateFeeRes>(
      `${this.#apiHost}operations/withdrawals/estimate/`,
      body,
    );
  }
}
